import type { CMSType } from '../types/cms'

export const cmsInitialValues: CMSType = {
  header: 'loading',
}
